import { Editor, EditorServices } from '../editors/base/editor';

export function mixinEditor<S extends EditorServices>(
  target: { new (...args: any[]): Editor<S> },
  mixin: Function,
): void {
  const mixinPropertyNames = Object.getOwnPropertyNames(mixin.prototype);
  for (const name of mixinPropertyNames) {
    // Treat the mixin like a superclass, and drop any properties that are overridden by the target.
    if (Object.prototype.hasOwnProperty.call(target.prototype, name)) {
      continue;
    }

    const prop = Object.getOwnPropertyDescriptor(mixin.prototype, name);
    if (!prop) {
      continue;
    }

    Object.defineProperty(target.prototype, name, prop);
  }
}
